<template>
  <v-layout>
    <v-flex xs12>
      <template v-if="loaded">
        <business-trip-request-form :title="title" :value="request" deletable refreshable @input="change"
                                    :editable="editable" :contentEditable="contentEditable"
                                    @close="close" @save="save" @delete="_delete" @refresh="refresh" />
        <router-view :editable="editable" employeeDetailRoute="business-trip-request-employee-detail"
                     employeeNewRoute="business-trip-request-new-employee"
                     employeeDetailBackRoute="business-trip-request-detail"
                     expenseListRoute="business-trip-request-expense"
                     expenseListBackRoute="business-trip-request-detail"
                     expenseNewRoute="business-trip-request-new-expense"
                     expenseDetailRoute="business-trip-request-expense-detail"></router-view>
      </template>
      <v-card v-else>
        <v-card-text><h2>Loading...</h2></v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Promise from 'promise-polyfill'
import BusinessTripRequestForm from './BusinessTripRequestForm'
import _ from 'lodash'

import Vuex from 'vuex'

const btRequestStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Request')
const btRequestEmployeeStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Employees')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'business-trip-request-detail',
  components: {
    BusinessTripRequestForm
  },
  data () {
    return {
      revision: false,
      request: {},
      contentEditable: false,
      loaded: false,
      modified: false
    }
  },
  computed: {
    title () {
      return 'Business Trip Request' + (this.revision ? ' (REVISION)' : '')
    },
    editable () {
      return this.request.documentState === 'DRAFTED' || this.request.documentState === 'REVISION'
    }
  },
  methods: {
    ...btRequestStore.mapActions({
      getRequest: 'getRequest',
      updateRequest: 'updateRequest',
      deleteRequest: 'deleteRequest'
    }),
    ...btRequestEmployeeStore.mapActions({
      getEmployees: 'getEmployees'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this

      // load all required resources
      const promises = [self.getRequest({vueinstance: self, id: self.$route.params.id})]
      Promise.all(promises)
        .then(res => {
          self.request = _.cloneDeep(res[0].content)
          self.contentEditable = res[0].editable
          if (self.request.documentState === 'REVISION') {
            self.revision = true
            self.request.documentState = 'DRAFTED'
          }
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    close () {
      const self = this
      if (self.modified) {
        const yesHandler = () => {
          self.$router.push({name: 'business-trip-request-list'})
          self.closeConfirmation()
        }

        const noHandler = () => {
          self.closeConfirmation()
        }

        this.showConfirmation({
          message: 'Are you sure?',
          title: 'Closing. Modified Business Trip Request ' + this.request.batchNo + ' will not saved',
          buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
        })
      } else {
        self.$router.push({name: 'business-trip-request-list'})
      }
    },
    save (request) {
      const self = this

      const simpan = () => {
        self.updateRequest({vueinstance: self, sppd: request})
          .then(res => {
            self.$success('Business Trip Request: ' + res.batchNo + ' saved')
            self.modified = false
            self.$router.push({name: 'business-trip-request-list'})
          })
          .catch(err => {
            self.$error(err)
          })
      }

      // check if employee request(s) exists
      if (request.documentState === 'SUBMITTED') {
        self.getEmployees({vueinstance: self, id: request.id})
          .then(res => {
            if (res.length === 0) {
              self.$error('Must have employee request(s)')
            } else {
              self.showConfirmation({
                title: 'Submit Business Trip Request. This process cannot be undone.',
                message: 'Are you sure?',
                buttons: [
                  { label: 'Yes',
                    handler: () => { simpan(); self.closeConfirmation() } },
                  { label: 'No', handler: () => self.closeConfirmation() }
                ]
              })
            }
          }).catch(err => {
            self.$error(err)
            self.closeConfirmation()
          })
      } else {
        simpan()
      }
    },
    _delete (request) {
      const self = this
      function yesHandler () {
        self.deleteRequest({vueinstance: self, sppd: self.request})
          .then(res => {
            self.$error('Business Trip Request ' + self.request.batchNo + ' was deleted')
            self.closeConfirmation()
            self.close()
          })
      }

      function noHandler () {
        self.closeConfirmation()
      }

      this.showConfirmation({message: 'Are you sure?',
        title: 'Delete Business Trip Request ' + this.request.batchNo,
        buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]})
    },
    refresh () {
      const self = this
      self.loaded = false

      // refresh
      const promises = [self.getRequest({vueinstance: self, id: self.$route.params.id})]
      Promise.all(promises)
        .then(res => {
          self.request = _.cloneDeep(res[0].content)
          self.contentEditable = res[0].editable
          self.loaded = true
          self.modified = false
        })
        .catch(err => self.$error(err))
    },
    change (request) {
      this.modified = true
    }
  },
  mounted () {
    this.loadResources()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestDetail.vue